import Navigator from 'app';
import WatchedBillModel from './watched_bill_model';
const WatchedBillCollection = Backbone.Collection.extend({
  model: WatchedBillModel,
  url: Navigator.config.api_base + 'watched_bills/'
});
const API = {
  getWatchedBills: function getWatchedBills() {
    var d = $.Deferred();
    var watchedBills = new WatchedBillCollection();
    watchedBills.fetch({
      dataType: "json",
      success: function (data) {
        d.resolve(data);
      }
    });
    return d.promise();
  }
};
Navigator.reqres.setHandler("watched_bill:list", function () {
  return API.getWatchedBills();
});
export { WatchedBillCollection as default };